import{css as r}from"styled-components";import{DARK_GRAY as o,YELLOW as s,LIGHTER_GRAY as e,WHITE as t,RED as n,DARKER_GRAY as d}from"../../../styles/Colors.mjs";const i=r`
  background-color: ${r=>r.$disabled?o:r.$isFocused?s:r.$isBlank?e:t};
  border-color: ${r=>r.$isError?n:r.$disabled?e:void 0};
  color: ${r=>{if(r.$disabled)return d}};
`;function l({$transparentBorder:r},o){return r?"transparent":o}export{i as changeColor,l as getBorderColorWithDefault};
